import { render, staticRenderFns } from "./PaymentsAndCurrenciesCurrencies.vue?vue&type=template&id=b92412f0&scoped=true&"
import script from "./PaymentsAndCurrenciesCurrencies.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndCurrenciesCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsAndCurrenciesCurrencies.vue?vue&type=style&index=0&id=b92412f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92412f0",
  null
  
)

export default component.exports